export default "__VITE_ASSET__BezY2__K__"